import { Injectable } from '@angular/core';
declare var google: any;
@Injectable()
export class DistancecalculService {

  dist?: number=null;

  constructor() {

  }

  getDistance(lat1:number, long1:number, lat2:number, long2:number):number{
    if(lat1==null||long1==null||lat2==null||long2==null)
      return null;
    // convert radian
    let latitude1=Math.PI*(lat1/180.0);
    let latitude2=Math.PI*(lat2/180.0);
    let longitude1=Math.PI*(long1/180.0);
    let longitude2=Math.PI*(long2/180.0);
    this.dist = Math.acos(Math.sin(latitude1) * Math.sin(latitude2) + Math.cos(latitude1) * Math.cos(latitude2) * Math.cos(longitude1-longitude2)) * 6371;
    this.dist=Math.round(this.dist*100);this.dist=this.dist/100.0;
      return this.dist;//Km
  }
  getRoadDistanceAndTime(from_latitude, from_longitude, to_latitudes, to_longitudes, callback) {
    let dests = [];
    let from = new google.maps.LatLng(from_latitude, from_longitude);
    for (let i = 0; i < to_latitudes.length; i++) {
      let dest = new google.maps.LatLng(to_latitudes[i], to_longitudes[i]);
      dests.push(dest);
    }
    let service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
        {
            origins: [from],
            destinations: dests,
            travelMode: 'DRIVING'
        }, callback);
  }
}
